<template>
    <div class="cell-box" @click="onClick">
        <div class="content-title" v-if="title">
            <span class="title-text">{{ title }}</span>
            <span v-if="isError" class="error-tips">{{ errorTips }}</span>
        </div>
        <div class="input" v-if="!readonly">
            <input
                v-if="['text', 'tel'].includes(inputType)"
                :type="inputType == 'username' ? 'text' : 'tel'"
                v-model="value"
                @blur="onBlur"
                :maxlength="maxlength"
                @focus="onFocus"
                :placeholder="placeholder"
            />
            <input
                class="intput_writable"
                v-else-if="inputType == 'input'"
                type="tel"
                v-model="value"
                :placeholder="placeholder"
                :maxlength="maxlength"
                @input="onInput"
            />
            <i @click="handleClear" class="input-close" v-show="clearable && value"></i>
        </div>
        <div class="input" v-else>
            <span class="input-text" v-if="value">{{ formatedValue }}</span>
            <span class="input-text placeholder" v-else>{{ placeholder }}</span>
            <i @click="handleClear" class="input-link" v-show="isLink && inputType != 'input'"></i>
        </div>
        <div class="line" :class="{ error: isError }"></div>
    </div>
</template>

<script>
export default {
    name: 'cellBox',
    props: {
        title: {
            type: String,
        },
        value: {
            type: [Number, String],
        },
        maxlength: {
            type: String,
            default: '',
        },
        placeholder: {
            type: [String, Number],
            default: '',
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        clickable: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        isLink: {
            type: Boolean,
            default: false,
        },
        formatter: {
            type: Function,
            default: null,
        },
        inputType: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isError: false,
            errorTips: '',
        };
    },
    computed: {
        formatedValue() {
            return this.formatter && typeof this.formatter === 'function' ? this.formatter(this.value) : this.value;
        },
    },
    methods: {
        onBlur() {
            setTimeout(() => {
                this.isShowDel = false;
            }, 200);
        },
        onFocus() {
            this.isShowDel = true;
            this.isError = false;
        },
        onInput() {
            this.$emit('input', this.value);
        },
        onClick(e) {
            if (!this.clickable || this.inputType == 'input') {
                return;
            }
            this.$emit('click', e);
        },
        handleClear() {
            this.$emit('input', '');
        },
    },
};
</script>

<style lang="scss" scoped>
.cell-box {
    padding: 0.3rem 0 0 0;
    & + .cell-box {
        margin: 0.1rem 0 0 0;
    }
}
.content-title {
    font-size: 0.28rem;
    margin-bottom: 0;
    color: #000;
}
.input {
    .intput_writable {
        width: 100%;
        height: 100%;
        font-size: 0.44rem;
    }
}
.title {
    font-size: 0.28rem;
    font-weight: 500;
    color: #000;
}
.input-text {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 0.24rem;
    box-sizing: border-box;
    white-space: nowrap;
    color: rgba(51, 51, 51, 1);
    &.placeholder {
        color: rgba(153, 153, 153, 1);
    }
}
.input-link {
    position: absolute;
    right: 0;
    top: 50%;
    width: 0.24rem;
    height: 0.24rem;
    transform: translateY(-50%);
    background: url('../../images/icon-arrow-right-2.png') center center / auto 100% no-repeat;
}
.error-tips {
    color: #fd0643;
    padding-left: 0.29rem;
    &:after {
        width: 0.28rem;
        height: 0.28rem;
        background-image: url('../../images/cy/icon-error@2x.png');
    }
}
</style>
